import { PlusIcon, Button, Heading, Tooltip } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { useHasScopePermission } from "app/hooks";

import { ADD_PROVIDER_PERMISSION_MESSAGE } from "./IdentityProviders/constants";

/**
 * Action bar for the Identity Providers settings page: the page title, and a
 * link to the add provider form.
 */
export function IdentityProvidersActionBar() {
  const navigate = useNavigate();

  const hasPermission = useHasScopePermission();
  const canManageProviders = hasPermission("system", "EDIT");

  return (
    <div className="mb-xl flex items-center justify-between gap-md">
      <Heading level={2}>Identity Providers</Heading>
      <Tooltip
        title={canManageProviders ? "" : ADD_PROVIDER_PERMISSION_MESSAGE}
        asChild
      >
        <span>
          <Button
            IconLeft={<PlusIcon className="h-4 w-4" />}
            isDisabled={!canManageProviders}
            onPress={() => navigate("add")}
            variant="primary"
          >
            Add Identity Provider
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
